import type { MessagingGetChatRoomById200LastMessageSenderBasicInfo } from './messagingGetChatRoomById200LastMessageSenderBasicInfo';
import type { MessagingGetChatRoomById200LastMessageSenderSocial } from './messagingGetChatRoomById200LastMessageSenderSocial';

/**
 * 발신자 정보
 */
export type MessagingGetChatRoomById200LastMessageSender = {
  /** 사용자 기본 정보 */
  basicInfo: MessagingGetChatRoomById200LastMessageSenderBasicInfo;
  /** 소셜 관계 정보 */
  social?: MessagingGetChatRoomById200LastMessageSenderSocial;
};
